export default __webpack_public_path__ + "static/check-magenta-b157390431597a34da573158956dcaef.png";